import React, { useContext } from "react";
import NavBar from "../../Components/NavBar";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import PrivacyTermsContent from "../../Components/PrivacyTermsContent/PrivacyTermsContent";
import { privacyDataConst } from "../../constants/PrivacyTermsConst";
import { LanguageContext } from "../../Hooks/langugaeContext";
import { useTranslation } from "../../Hooks/useTranslation";

function Privacy() {
  const { language } = useContext(LanguageContext);
  const translations = useTranslation();
  useAnimateOnScroll();
  return (
    <div>
      <NavBar onlyWhiteBg={true} />
      <PrivacyTermsContent
        title={translations.privacyPageTitle}
        content={privacyDataConst[language]}
      />
    </div>
  );
}

export default Privacy;
